import $ from 'jquery';
import _ from 'underscore';
import Cache from 'root/cache';
import View from 'view/base';

var Emoji = View.extend({
    className: 'emoji-selector',

    emoji_list: {},
    data: [],

    events: {
        'click .emoji-char'         : 'onSelect',
        'keyup .emoji-search input' : 'onSearch'
    },

    dom_handlers: {
        onSelect: function(e) {
            if (typeof this.onSelect === 'function') {
                this.onSelect($(e.currentTarget).html());
            }
        },

        onSearch: function(e) {
            if (!this.is_loaded) {
                return;
            }

            clearTimeout(this.search_timeout);

            this.search_timeout = setTimeout(function() {
                var search_value = $(e.currentTarget).val().trim();
                this.buildEmojiList(Cache.get('emoji_list'), search_value);
            }.bind(this), 300);
        },

        documentClick: function(e) {
            if ($.contains(this.el, e.target)) {
                return;
            }

            if ($.contains(this.launcher.get(0), e.target)) {
                return;
            }

            if (e.target === this.launcher.get(0)) {
                return;
            }

            this.$el.hide();
        }
    },

    initialize: function(options) {
        this.onSelect = options.onSelect || undefined;
        this.launcher = options.launcher;

        this.on('remove', function() {
            $(document).off('click.emoji_doc');
        });

        $(document).on('click.emoji_doc', this.dom_handlers.documentClick.bind(this));
    },

    load: function() {
        if (this.is_loaded) {
            return;
        }

        var data = Cache.get('emoji_list');

        if (!data) {
            this.$el.addClass('loader loader-small');

            Cache.app.request({
                action: 'feedback\\Comment/getEmoji',
                context: this,
                success: function(data) {
                    this.$el.removeClass('loader loader-small');
                    this.buildEmojiList(data);
                    Cache.add('emoji_list', data, false);
                    this.is_loaded = true;
                }
            });
        } else {
            this.buildEmojiList(data);
            this.is_loaded = true;
        }
    },

    buildEmojiList: function(data, search_value) {
        this.$el.find('.emoji-group-container').remove();

        if (_.size(this.emoji_list) === 0) {
            _.each(data, function(emoji) {
                if (typeof this.emoji_list[emoji.group] === 'undefined') {
                    this.emoji_list[emoji.group] = [];
                }

                this.emoji_list[emoji.group].push(emoji);
            }, this);
        }

        _.each(this.emoji_list, function(list, group_name) {
            var emoji_group_container = $('<div class="emoji-group-container">');

            var is_empty = true;
            _.each(list, function(emoji) {
                if (!search_value || emoji.name.indexOf(search_value) !== -1) {
                    emoji_group_container.append($('<span data-abc="'+emoji.codes+'" class="emoji-char">').text(emoji.char));
                    is_empty = false;
                }
            }, this);

            if (!is_empty) {
                $('<div class="emoji-group-title">').text(group_name).prependTo(emoji_group_container);
                emoji_group_container.appendTo(this.$el);
            }
        }, this);
    },

    show: function() {
        this.$el.show();
    },

    hide: function() {
        this.$el.hide();
    },

    toggle: function() {
        this.$el.toggle();
    },

    render: function() {
        var content = '<div class="emoji-search">' +
                            '<i class="far fa-search"></i>' +
                            '<input type="text" placeholder="Search">' +
                        '</div>';

        this.$el.html(content);

        return this;
    }
});

export default Emoji;
